import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
// import {menuSteps} from "./TourUtils";
import TourBase from "./tour-base/TourBase";
import TourStepContentSmall from "./TourStepContentSmall";
import {
  setToursMenuFilters,
  setStatusTourMenu
} from "../../actions/TourAction";
class BunkeyMenuTour extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stepsLocal: []
    };
    this.current = -1;
  }
  componentDidMount() {
    const { user, tourMenu, tourMenuFiltersFinished } = this.props;

    if (user && tourMenu && tourMenu.length !== 0 && !tourMenuFiltersFinished) {
      var newMenus = [];
      var type_user = null;
      if (user.role === "admin") {
        type_user = "superadmin";
      } else {
        type_user = user.clientRole;
      }
      tourMenu.forEach(r => {
        r.classname = "s_menu_" + r.number;
        if (r.type_user === "all") {
          newMenus.push({ ...r });
        } else {
          if (type_user === r.type_user) {
            newMenus.push({ ...r });
          }
          if (
            (type_user === "admin" || type_user === "superadmin") &&
            r.type_user === "su-admin"
          ) {
            newMenus.push({ ...r });
          }
        }
      });
      this.props.setToursMenuFilters(newMenus);
      if (newMenus.length === 0) {
        this.props.setStatusTourMenu(true);
      }
      this.setState({
        stepsLocal: newMenus
      });
    }
  }
  render() {
    const {
      onChangePage,
      onAfterOpen,
      onBeforeClose,
      onTourNotOpened,
      onRequestClose,
      intl
    } = this.props;
    const { stepsLocal } = this.state;
    const savedColor = localStorage.getItem("primaryColor");
    var menuSteps = [];
    if (stepsLocal && stepsLocal.length !== 0) {
      stepsLocal.forEach(r => {
        r.content = (
          <TourStepContentSmall
            title={intl.formatMessage({ id: "menu_" + r.title })}
            subtitle={intl.formatMessage({ id: "menu_" + r.description })}
          />
        );
        menuSteps.push({ ...r });
      });
    }
    return (
      <React.Fragment>
        {menuSteps && menuSteps.length > 0 && (
          <TourBase
            accentColor={savedColor}
            identifier="menu_tour"
            steps={menuSteps}
            onChangePage={onChangePage}
            onAfterOpen={onAfterOpen}
            onBeforeClose={onBeforeClose}
            onTourNotOpened={onTourNotOpened}
            onRequestClose={onRequestClose}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.authUser.user,
    token: state.authUser.token,
    tourMenu: state.tours.tourMenu,
    tourMenuFilters: state.tours.tourMenuFilters,
    tourMenuFiltersFinished: state.tours.tourMenuFiltersFinished
  };
};

const mapDispatchToProps = {
  setToursMenuFilters,
  setStatusTourMenu
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(BunkeyMenuTour))
);
